<template>
  <div class="service-declaration">
    <div class="block">
      <div class="warning info">
        <p>{{ warningText }}</p>
      </div>
      <h2 class="label">
        {{ $t('labels.atendimentos') }}
      </h2>
      <b-field>
        <b-radio
          name="name"
          @input="() => (filterDataOption = false)"
          native-value="Todos"
        >
          {{ $t('labels.todos') }}
        </b-radio>
      </b-field>
      <b-field>
        <b-radio name="name" @input="() => (filterDataOption = true)">
          {{ $t('labels.periodo') }}
        </b-radio>
      </b-field>
      <filter-data
        v-if="filterDataOption"
        :datas.sync="filter"
        @date-ready="handleData"
      />
    </div>
  </div>
</template>

<script>
import FilterData from '@/components/shared/filter/FilterData'
import { mapGetters, mapMutations } from 'vuex'
import { formatISO } from 'date-fns'
export default {
  components: {
    FilterData
  },
  data() {
    return {
      radioChecked: '',
      filter: {
        pagina: 0,
        tamanho: 8
      },
      filterDataOption: true,
      warningText: this.$t('documentos.aviso-validacao-digital')
    }
  },
  computed: {
    ...mapGetters({
      getDateFilter: 'getDateFilter'
    })
  },
  updated() {
    this.handleData()
  },
  methods: {
    ...mapMutations(['DESABILITAR_BOTAO_ENVIAR']),
    handleData() {
      if (
        (this.filter.dataInicio && this.filter.dataTermino) ||
        !this.filterDataOption
      ) {
        if (this.filter.dataInicio && this.filter.dataTermino) {
          this.getDateFilter.initDate = formatISO(this.filter.dataInicio)
          this.getDateFilter.endDate = formatISO(this.filter.dataTermino)
        }
        this.DESABILITAR_BOTAO_ENVIAR(false)
        return
      }

      this.DESABILITAR_BOTAO_ENVIAR(true)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/stylesheets/base';
@import '~@/assets/stylesheets/forms';
@import '~@/assets/stylesheets/warnings';
.service-declaration {
  margin-top: 2rem;
  .block {
    margin-top: 2rem;
    max-width: 80%;
    padding-bottom: 2.5rem;
  }
  .warning.info {
    margin: 1.5rem 0;
  }
}
@media (max-width: $mobile-width-breakpoint) {
  .service-declaration {
    .block {
      max-width: 100%;
    }
    .warning {
      max-width: 100%;
    }
  }
}
</style>
